import { useEffect, useState } from 'react';
import Slider from '@mui/material/Slider';
import { TextField } from '@salutejs/sdds-insol';
import { NUMBERS_REG_EXP } from '@/shared/const';
import cls from './RangeInput.module.scss';

type Props = {
    disabled?: boolean;
    disableInput?: boolean;
    hideFieldSymbol?: boolean;
    hideRangeSymbol?: boolean;
    max: number;
    maxLength?: number;
    min: number;
    placeholder: string;
    size?: 'l' | 'm' | 's' | 'xl' | 'xs';
    step?: number;
    symbol: string;
    value: number;
    onBlur?: () => void;
    onChange: (value: number) => void;
};

export const RangeInput = ({
    disabled,
    value,
    hideRangeSymbol = false,
    hideFieldSymbol = false,
    disableInput = false,
    size = 'xl',
    min,
    max,
    onChange,
    onBlur,
    placeholder,
    symbol,
    step,
    maxLength,
}: Props) => {
    const [sliderValue, setSliderValue] = useState(value);

    useEffect(() => {
        if (value !== sliderValue) {
            setSliderValue(value);
        }
    }, [value]);

    const rangeSymbol = hideRangeSymbol ? '' : ' ' + symbol;
    const fieldSymbol = hideFieldSymbol ? '' : ' ' + symbol;

    return (
        <div className={cls.sliderInput}>
            <TextField
                className={disableInput ? cls.disableInput : undefined}
                size={size}
                label={placeholder}
                maxLength={maxLength}
                labelPlacement="inner"
                value={sliderValue.toLocaleString('ru-RU') + fieldSymbol}
                onBlur={onBlur}
                onChange={(e) => {
                    const preparedValue = e.target.value ? e.target.value.replace(' ', '') : '';

                    const isPassed = NUMBERS_REG_EXP.test(preparedValue);

                    if (preparedValue && !isPassed) {
                        e.stopPropagation();

                        return;
                    }

                    setSliderValue(Number(preparedValue));
                    onChange?.(Number(preparedValue));
                }}
            />
            <Slider
                className={cls.slider}
                classes={{
                    rail: cls.slider__rail,
                    track: cls.slider__track,
                    thumb: cls.slider__thumb,
                }}
                min={min}
                max={max}
                step={step}
                value={sliderValue}
                onChange={(_, value) => {
                    if (disabled) {
                        return;
                    }
                    setSliderValue(value as number);
                }}
                onChangeCommitted={(_, value) => {
                    if (disabled) {
                        return;
                    }
                    onChange?.(value as number);
                }}
            />
            <div className={cls.minMaxContainer}>
                <p className={cls.min}>{min.toLocaleString('ru-RU') + rangeSymbol}</p>
                <p className={cls.max}>{max.toLocaleString('ru-RU') + rangeSymbol}</p>
            </div>
        </div>
    );
};
